import { IoBarChartSharp } from 'react-icons/io5'
import { MdQueryStats } from 'react-icons/md'
import { ImProfile } from 'react-icons/im'

const links = [
  { id: 1, text: 'Monatsverlauf', path: '/', icon: <IoBarChartSharp /> },
  { id: 2, text: 'Monatsvergleich', path: '/monthly-comparison', icon: <IoBarChartSharp /> },
  { id: 3, text: 'Jahresvergleich', path: 'annual-comparison', icon: <IoBarChartSharp /> },
  { id: 4, text: 'Alle Einträge', path: 'all-informationItems', icon: <MdQueryStats /> },
  { id: 5, text: 'Profil', path: 'profile', icon: <ImProfile /> },
]

export default links